<template>
  <div>
    <v-row v-if="showToggleButton">
      <v-col cols="12" class="toggleWrapper">
        <input v-model="isToggleEnabled" type="checkbox" class="toggle" />
        <span>Schedule</span>
      </v-col>
    </v-row>
    <v-row v-if="isToggleEnabled">
      <v-col cols="6">
        <datetime v-model="startDate"
                  type="date"
                  placeholder="Select start date"
                  :min-datetime="new Date().toISOString()"
                  zone="local"
                  value-zone="local"
                  auto />
      </v-col>
      <v-col cols="6">
        <vue-timepicker v-if="startDate"
                        v-model="time"
                        :minute-interval="5"
                        format="HH:mm"
                        drop-direction="up"
                        placeholder="Select a time"
                        :drop-offset-height="300"
                        :hour-range="_getValidHourRanges()"
                        :minute-range="_getValidMinuteRanges()"
                        close-on-complete
                        auto-scroll />
      </v-col>
    </v-row>
    <v-row v-if="isToggleEnabled">
      <v-col cols="6">
        <datetime v-model="endDate"
                  type="date"
                  placeholder="Select a end date (Optional)"
                  :min-datetime="startDate ? startDate : new Date().toISOString()"
                  zone="local"
                  value-zone="local"
                  auto />
      </v-col>
    </v-row>
    <v-row v-if="isToggleEnabled">
      <v-col cols="6">
        <span>Frequency</span>
        <div class="select-dropdown">
          <select v-model="selectedFrequency">
            <option v-for="(item, i) in CONST.ALL_FREQUENCIES" :key="i" :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  /* eslint-disable */
  import moment from "moment";
  import { Datetime } from "vue-datetime";
  // You need a specific loader for CSS files
  import "vue-datetime/dist/vue-datetime.css";
  import "vue2-timepicker/dist/VueTimepicker.css";
  // Main JS (in UMD format)
  import VueTimepicker from "vue2-timepicker";
  import CONST from "../../../../const";

  export default {
    name: "MessageScheduler",
    components: {
      datetime: Datetime,
      VueTimepicker: VueTimepicker
    },
    props: {},
    data: () => ({
      CONST,
      isToggleEnabled: false,
      showToggleButton: true,
      shouldSchedule: false,
      selectedFrequency: 0,
      time: "",
      startDate: "",
      endDate: ""
    }),
    watch: {
      showToggleButton(val) {
        this.$emit("update:showToggleButton", val);
      },
      shouldSchedule(val) {
        this.$emit("update:shouldSchedule", val);
      },
      selectedFrequency(val) {
        this.$emit("update:selectedFrequency", val);
      },
      startDate(val) {
        this.$emit("update:startDate", val);
      },
      time(val) {
        this.$emit("update:time", val);
      },
      endDate(val) {
        this.$emit("update:endDate", val);
      },
      isToggleEnabled(val) {
        this.$emit("update:isToggleEnabled", val);
        this.isToggleEnabled = val;
      },
    },
    methods: {
      _getValidMinuteRanges() {
        let validMinuteRange = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            if (this.time) {
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              const currentHour = parseInt(moment().format("H"));
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              let selectedHour = parseInt(this.time.split(":")[0]);
              const selectedformat = this.time.split(" ")[1];
              // eslint-disable-next-line no-restricted-globals
              if (selectedformat === "pm" && !isNaN(selectedHour)) {
                selectedHour += 12;
              }
              if (selectedHour === currentHour) {
                // eslint-disable-next-line no-undef
                // eslint-disable-next-line radix
                const currentMinute = parseInt(moment().format("m"));
                const allowedMinuteRanges = [15, 30, 45];
                validMinuteRange = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const allowedMinuteRange of allowedMinuteRanges) {
                  if (allowedMinuteRange >= currentMinute) {
                    validMinuteRange.push(allowedMinuteRange);
                  }
                }
              }
            } else {
              validMinuteRange = [];
            }
          }
        }
        return validMinuteRange;
      },
      _getValidHourRanges() {
        let validHourRange = [[1, 23]];
        var currentHour = parseInt(moment().format("HH"));
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            const currentMinute = parseInt(moment().format("m"));
            if (currentMinute < 45) {
              validHourRange = [[currentHour, 23]];
            } else {
              validHourRange = [[currentHour + 1, 23]];
            }
          }
        }
        return validHourRange;
      }
    },
    created() {
      this.isToggleEnabled = true;
    }
  };
</script>

<style lang="scss" scoped>
  .toggleWrapper {
    display: flex;
    align-items: center;

    span {
      font-size: 1.1rem;
      margin-left: 1rem;
    }

    input[type="checkbox"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
    }

    input[type="checkbox"]:focus {
      outline: 0;
    }

    .toggle {
      height: 16px;
      width: 42px;
      border-radius: 16px;
      display: inline-block;
      position: relative;
      margin: 0;
      border: 2px solid grey;
      background: grey;
      transition: all 0.2s ease;
    }

    .toggle:after {
      content: "";
      position: absolute;
      top: 0px;
      left: 4px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: white;
      box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
      transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }

    .toggle:checked {
      border-color: rgb(0, 182, 91);
      background: rgb(0, 185, 108);
    }

    .toggle:checked:after {
      transform: translatex(20px);
    }
  }
</style>
